import isEmpty from 'lodash.isempty';

export const removeKeysFromObject = <
  T extends Record<string, any>,
  K extends keyof T,
>(
  obj: T,
  keys: K[],
): Omit<T, K> => {
  if (!Array.isArray(keys) || isEmpty(obj)) {
    return {} as T;
  }

  if (isEmpty(keys) && !isEmpty(obj)) {
    return obj;
  }
  return Object.keys(obj)
    .filter((key) => !keys.includes(key as K))
    .reduce((acc, key) => ({ ...acc, [key]: obj[key] }), {} as Omit<T, K>);
};
